import { client } from "./supabase";

export const getMovimientosCaja = async (pais, filters = {}) => {
  let query = client
    .from("movimientos_caja")
    .select("*")
    .eq("pais", pais)
    .neq("estado", "anulado")
    .order("fecha", { ascending: false });

  if (filters.tipo) query = query.eq("tipo", filters.tipo);
  if (filters.fechaDesde) query = query.gte("fecha", filters.fechaDesde);
  if (filters.fechaHasta) query = query.lte("fecha", filters.fechaHasta);
  if (filters.entidad_tipo) query = query.eq("entidad_tipo", filters.entidad_tipo);

  const { data, error } = await query;
  if (error) throw error;
  return data || [];
};

export const crearMovimiento = async (movimientoData) => {
  const { data, error } = await client.from("movimientos_caja").insert([movimientoData]).select();
  if (error) throw error;
  return data?.[0];
};

export const actualizarMovimiento = async (id, movimientoData) => {
  const { data, error } = await client
    .from("movimientos_caja")
    .update({ ...movimientoData, updated_at: new Date().toISOString() })
    .eq("id", id)
    .select();
  if (error) throw error;
  return data?.[0];
};

export const anularMovimiento = async (id) => {
  const { error } = await client
    .from("movimientos_caja")
    .update({ estado: "anulado", updated_at: new Date().toISOString() })
    .eq("id", id);
  if (error) throw error;
};

// Crear movimiento padre + hijo vinculado
export const crearMovimientoConHijo = async (parentData, childData) => {
  const parent = await crearMovimiento(parentData);
  if (!parent) throw new Error("Error creando movimiento padre");
  const child = await crearMovimiento({ ...childData, movimiento_padre_id: parent.id });
  return { parent, child };
};

// Anular movimiento y todos sus hijos
export const anularMovimientoConHijos = async (parentId) => {
  const { data: children, error } = await client
    .from("movimientos_caja")
    .select("id")
    .eq("movimiento_padre_id", parentId)
    .neq("estado", "anulado");
  if (error) throw error;
  for (const child of children || []) {
    await anularMovimiento(child.id);
  }
  await anularMovimiento(parentId);
  return { anulados: (children || []).length + 1 };
};
